import { render } from "./ContactDetail.vue?vue&type=template&id=5ec7be96&ts=true"
import script from "./ContactDetail.vue?vue&type=script&lang=ts"
export * from "./ContactDetail.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__